<template>
    <div id="agaccount" class='gcardfr' v-loading='loading'>

        <el-row :gutter="20" class=''>
            <el-col :span='8'>
                <div class="glineflex">
                    <label class="glinelb">商户ID：</label>
                    <el-input size='small' v-model='merchantId' @keyup.enter.native="indexget"></el-input>
                </div>
            </el-col>

        </el-row>
        <el-table class='gtbtop' tooltip-effect="dark" :data="tableData" style="width: 100%">
            <el-table-column prop="merchantId" label="商户ID" width="200">
            </el-table-column>
            <el-table-column prop="merchantName" label="商户名称" width="200">
            </el-table-column>
            <el-table-column prop="merchantPhone" label="商户电话" width="200">
            </el-table-column>
            <el-table-column prop="contactName" label="联系人" width="200">
            </el-table-column>
            <el-table-column prop="businessScope" label="经营类型" width="200">
                <template slot-scope="scope">
                    <span v-if="scope.row.businessScope == '0'">餐饮店</span>
                    <span v-if="scope.row.businessScope == '1'">零售店</span>
                    <span v-if="scope.row.businessScope == '2'">移动摊位</span>
                    <span v-if="scope.row.businessScope == '3'">菜市场</span>
                </template>
            </el-table-column>
            <el-table-column prop="loginIp" label="登录IP" width="200">
            </el-table-column>
            <el-table-column prop="loginDate" label="登录时间" width="200">
            </el-table-column>
            <el-table-column label="状态" width="200">
                <template slot-scope="scope">
                    {{ scope.row.status == '1' ? '禁用' : '启用' }}
                </template>
            </el-table-column>
            <el-table-column prop="createTime" label="创建时间" width="200">
            </el-table-column>
            <el-table-column :label="$t('app_operation')" width="200" fixed="right">
                <template slot-scope="scope">
                    <el-button v-if="scope.row.status == '1'" type='text'
                        @click='switching(scope.row, "0")'>启用</el-button>
                    <el-button v-else type='text' @click='switching(scope.row, "1")'>禁用</el-button>
                    <el-button type='text' @click='open(scope.row)'>重置密码</el-button>
                </template>
            </el-table-column>
        </el-table>

        <Pages class='gpages' :cpage='page' :ctotal="total" :config='pconfig'></Pages>
    </div>
</template>

<script>
import Pages from '@/components/Pages.vue'
import sha256 from "js-sha256";
export default {
    data() {
        return {
            merchantId: '',
            forms: {},
            isEdit: false,
            srcKey: '',
            pconfig: '',
            tableData: [],
            showDia: false,
            uform: {
                strategyData: {}
            },
            page: 1,
            total: 0,
            loading: false,
            sRows: [],
            innerVisible: false,
            beginTime: '',
            endTime: '',
        }
    },
    components: {
        Pages,
    },
    methods: {
        open(item) {
            this.$prompt('请输入密码', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputPattern: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,20}$/,
                inputErrorMessage: '8 ~ 20个字符，必须包含数字、大写字母和小写字母。'
            }).then(({ value }) => {
                console.log('value', value)
                this.loading = true
                this.$marketMerchant_retPas(item.id, sha256(value), res => {
                    this.loading = false
                    if (res.status == 200) {
                        this.getList()
                        this.$message.success(res.message)
                    } else {
                        this.$message.error(res.message)
                    }
                }, '')
            }).catch(() => {

            });
        },
        switching(item, idx) {
            this.loading = true
            this.$marketMerchant_disable(item.id, idx, res => {
                this.loading = false
                if (res.status == 200) {
                    this.getList()
                } else {
                    this.$message.error(res.message)
                }
            }, '')
        },
        indexget() {
            this.page = 1
            this.getList()
        },
        getList() {
            this.loading = true
            this.$marketMerchant(this.page, this.$gRow, this.merchantId, res => {
                this.loading = false
                if (res.status == 200) {
                    this.total = res.total
                    this.tableData = res.data
                } else {
                    this.$message.error(res.message)
                }
            }, '')
        },
        batchSelected(val) {
            this.sRows = val
        },
        closeDia() {
            this.showDia = false
            this.uform = { strategyData: {} }
        },
    },
    mounted() {
        var _this = this
        this.pconfig = {
            callback: page => {
                ///
                _this.page = page
                _this.getList()
            }
        }

        // this.setMc('')

        this.getList()
    }
}
</script>
